
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

 
import { HomeComponent } from './pages/home/home.component';
import { NavbarComponent } from './components/home/navbar/navbar.component';
import { HeadimgComponent } from './components/home/headimg/headimg.component';
import { HomeservicesComponent } from './components/home/homeservices/homeservices.component';
import { HomedataplansComponent } from './components/home/homedataplans/homedataplans.component';
import { HomecoverageComponent } from './components/home/homecoverage/homecoverage.component';
import { HomefooterComponent } from './components/home/homefooter/homefooter.component';
import { NavmenuComponent } from './components/navmenu/navmenu.component';
import { HomeoffersComponent } from './components/home/homeoffers/homeoffers.component';

import { PersonalComponent } from './pages/personal/personal.component';
import { BusinessContentComponent } from './components/business/business-content/business-content.component';
import { BusinessComponent } from './pages/business/business.component';
import { SigninComponent } from './pages/signin/signin.component';
import { LoginComponent } from './components/common/login/login.component';

import { DealersContentComponent } from './components/dealers/dealers-content/dealers-content.component';
import { DealersComponent } from './pages/dealers/dealers.component';
import { CoverageComponent } from './pages/coverage/coverage.component';
import { CoverageContentComponent } from './components/coverage/coverage-content/coverage-content.component';

import { CheckoutComponent } from './pages/checkout/checkout.component';
import { PersonalDataPlansComponent } from './components/personal/personal-data-plans/personal-data-plans.component';
import { CheckoutContentComponent } from './components/activated/checkout-content/checkout-content.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DashboardMenuComponent } from './components/selfcareadmin/dashboard-menu/dashboard-menu.component';
import { AdminTopComponent } from './components/selfcareadmin/admin-top/admin-top.component';
import { DashboardHomeComponent } from './components/selfcareadmin/dashboard-home/dashboard-home.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AlertComponent } from './components/common/alert/alert.component';
import { BalanceComponent } from './pages/balance/balance.component';
import { CurrentdataComponent } from './components/selfcareadmin/currentdata/currentdata.component';
import { UsageComponent } from './pages/usage/usage.component';
import { UsageReportComponent } from './components/selfcareadmin/usage-report/usage-report.component';
import { ManageComponent } from './pages/manage/manage.component';
import { ManageAccountComponent } from './components/selfcareadmin/manage-account/manage-account.component';
import { EWalletComponent } from './components/selfcareadmin/e-wallet/e-wallet.component';
import { WalletComponent } from './pages/wallet/wallet.component';
import { LoansComponent } from './pages/loans/loans.component';
import { LoanComponent } from './components/selfcareadmin/loan/loan.component';
import { GetdataComponent } from './components/selfcareadmin/getdata/getdata.component';
import { BuydataComponent } from './pages/buydata/buydata.component';
import { DevicelistComponent } from './components/devicelist/devicelist.component';
import { DevicesComponent } from './pages/devices/devices.component';
import { AccountDetailComponent } from './pages/account-detail/account-detail.component';

import { NgZorroAntdModule, NZ_I18N, en_US } from 'ng-zorro-antd';


import { DeviceinfoComponent } from './selfcareadmin/deviceinfo/deviceinfo.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 
import { ActivatevoiceComponent } from './pages/activatevoice/activatevoice.component';
import { VoiceregComponent } from './components/voicereg/voicereg.component';
import { EndCyberpayComponent } from './components/end-cyberpay/end-cyberpay.component';
import { CompletePaymentComponent } from './pages/complete-payment/complete-payment.component';
import { RenewplanComponent } from './components/renewplan/renewplan.component';
import { RenewplanpageComponent } from './pages/renewplanpage/renewplanpage.component';

import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { ToastrModule } from 'ngx-toastr';
import { CyberPayVerifyComponent } from './components/cyber-pay-verify/cyber-pay-verify.component';
import { TopupComponent } from './components/selfcareadmin/topup/topup.component';
import { TopupPageComponent } from './pages/topup-page/topup-page.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { CartoutComponent } from './components/cartout/cartout.component';
import { CartcheckoutComponent } from './pages/cartcheckout/cartcheckout.component'
import { RenewplanvoiceComponent } from './components/renewplanvoice/renewplanvoice.component';
import { RenewplanvoicepageComponent } from './pages/renewplanvoicepage/renewplanvoicepage.component'
import { HttpConfigInterceptor } from "./interceptors/apphttpinterceptor";
import { FundwalletComponent } from './components/fundwallet/fundwallet.component';
import { FundwalletpageComponent } from './pages/fundwalletpage/fundwalletpage.component';
import { RequestloanComponent } from './components/requestloan/requestloan.component';
import { RequestloanpageComponent } from './pages/requestloanpage/requestloanpage.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NavmenupersonalComponent } from './components/navmenupersonal/navmenupersonal.component';
import { TimeDiffPipe } from './model/TimeDiffPipe';
import { ChangepwdComponent } from './components/changepwd/changepwd.component';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { ArchwizardModule } from 'angular-archwizard';
import { ForgotpwdComponent } from './components/forgotpwd/forgotpwd.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
 
import { BnNgIdleService } from 'bn-ng-idle';
import { AgmCoreModule } from '@agm/core';
import { NgxCaptchaModule } from 'ngx-captcha/lib';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { PayhistoryComponent } from './components/payhistory/payhistory.component';
import { TransactionhistoryComponent } from './pages/transactionhistory/transactionhistory.component';
import { OnlynumberDirective } from './components/onlynumber.directive';
import { KycupldComponent } from './components/kycupld/kycupld.component';
import { KycComponent } from './components/pages/kyc/kyc.component';
import { MailsubscriptionContentComponent } from './components/mailsubscription/mailsubscription-content/mailsubscription-content.component';
import { MailsubscriptionComponent } from './pages/mailsubscription/mailsubscription.component';
import { NinComponent } from './pages/nin/nin.component';
import { NinContentComponent } from './components/nin-content/nin-content.component';

 
 
 

/** config angular i18n **/
/*
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
registerLocaleData(en);*/
 
 
 

@NgModule({
  declarations: [
    AppComponent,  
      HomeComponent, 
      NavbarComponent, 
      HeadimgComponent, HomeservicesComponent,
       HomedataplansComponent, HomecoverageComponent, 
       HomefooterComponent, NavmenuComponent, HomeoffersComponent,
        PersonalDataPlansComponent, PersonalComponent, BusinessContentComponent,
         BusinessComponent, SigninComponent, LoginComponent, 
           DealersContentComponent, DealersComponent, CoverageComponent, 
         CoverageContentComponent, CheckoutContentComponent, CheckoutComponent, DashboardMenuComponent, AdminTopComponent, DashboardHomeComponent, DashboardComponent,
         AlertComponent, BalanceComponent, CurrentdataComponent, UsageComponent, UsageReportComponent, ManageComponent, ManageAccountComponent, EWalletComponent, WalletComponent, LoansComponent, LoanComponent, GetdataComponent, BuydataComponent, DevicelistComponent, DevicesComponent, AccountDetailComponent, 
         DeviceinfoComponent,   ActivatevoiceComponent, VoiceregComponent, EndCyberpayComponent, CompletePaymentComponent,
          RenewplanComponent, RenewplanpageComponent, CyberPayVerifyComponent, TopupComponent, 
         TopupPageComponent, CartoutComponent, CartcheckoutComponent
         ,        TopupComponent, TopupPageComponent,      
         RenewplanvoiceComponent, RenewplanvoicepageComponent
         ,TimeDiffPipe
              , RenewplanComponent, RenewplanpageComponent, CyberPayVerifyComponent, TopupComponent, TopupPageComponent, RenewplanvoiceComponent, RenewplanvoicepageComponent, FundwalletComponent, FundwalletpageComponent, RequestloanComponent, RequestloanpageComponent,  NavmenupersonalComponent, ChangepwdComponent, WelcomeComponent, ForgotpwdComponent, 
              ForgotPasswordComponent, PayhistoryComponent, TransactionhistoryComponent,
              OnlynumberDirective,
              KycupldComponent,
              KycComponent,MailsubscriptionContentComponent,MailsubscriptionComponent, NinComponent, NinContentComponent
              
    
         
              

      
          
   
 
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,    
    ReactiveFormsModule, 
    NgZorroAntdModule,
    ArchwizardModule,
    
     HttpClientModule,
      SelectDropDownModule,
    BrowserAnimationsModule,
    LoadingBarHttpClientModule,LoadingBarRouterModule,ToastrModule.forRoot(),
    UiSwitchModule.forRoot({
      size: 'small',
      color: '#0486D7',
      switchColor: '#80FFA2',
      defaultBgColor: '#00ACFF',
      defaultBoColor : '#476EFF',
      checkedLabel: 'on',
      uncheckedLabel: 'off'
    }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDsSbBCD1aUnAQZp0oy2MyEOhLRDDKAKKM'
    })
    ,RecaptchaModule
     
   // toastr.notification.module
    
  ],
  providers: [ { provide: NZ_I18N, useValue: en_US },
    BnNgIdleService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
